(() => {
  const SUMMARY_STATE_KEY = '__cartDrawerV2SummaryState';
  const INSTANCE_KEY = '__cartDrawerV2Summary';

  if (window[INSTANCE_KEY]) {
    return;
  }

  class CartDrawerV2Summary {
    constructor() {
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.state = window[SUMMARY_STATE_KEY] || { detailsOpen: false };
      window[SUMMARY_STATE_KEY] = this.state;
    }

    mount() {
      document.addEventListener('liquid-ajax-cart:queue-end', this.handleCartUpdate);
      document.addEventListener('cart:updated', this.handleCartUpdate);
      document.addEventListener('click', this.handleDocumentClick);
      this.sync();
    }

    handleCartUpdate() {
      this.sync();
    }

    handleDocumentClick(event) {
      const toggle = event.target.closest('.cart-drawer-v2__totals__total__toggle');

      if (!toggle) {
        return;
      }

      window.requestAnimationFrame(() => {
        const details = document.querySelector('#CartDrawerV2 .cart-drawer-v2__totals__details');
        this.state.detailsOpen = details ? !details.classList.contains('hidden') : false;
      });
    }

    sync() {
      const cartDrawer = document.querySelector('#CartDrawerV2');

      if (cartDrawer) {
        this.restoreDetailsState(cartDrawer);
      }

      const cart = this.getCart();

      if (!cart) {
        return;
      }

      if (cartDrawer) {
        this.updateDivideBuySummary(cartDrawer, cart);
      }

      this.updateDivideBuyModal(cart);
    }

    getCart() {
      return window.liquidAjaxCart?.getState?.()?.cart || window.liquidAjaxCart?.cart || null;
    }

    getThemeState() {
      return window.__Theme?._ctx?.getState?.() || null;
    }

    getDivideBuyMinimumSpend() {
      return Number(this.getThemeState()?.dividebuyMinimumSpend || 0) * 100;
    }

    getDivideBuyThresholds() {
      const thresholds = this.getThemeState()?.dividebuyThresholds;

      if (!Array.isArray(thresholds)) {
        return [];
      }

      return thresholds
        .map((entry) => {
          const [threshold, months] = String(entry).split(':');

          return {
            threshold: Number(threshold) * 100,
            months: Number(months),
          };
        })
        .filter((option) => Number.isFinite(option.threshold) && Number.isFinite(option.months) && option.months > 0);
    }

    getOptimalPaymentMonths(price) {
      const qualifyingOptions = this.getDivideBuyThresholds().filter((option) => price >= option.threshold);

      if (!qualifyingOptions.length) {
        return null;
      }

      return qualifyingOptions.reduce((best, current) => (
        current.months > best.months ? current : best
      )).months;
    }

    restoreDetailsState(cartDrawer) {
      const details = cartDrawer.querySelector('.cart-drawer-v2__totals__details');
      const showDetails = cartDrawer.querySelector('.cart-drawer-v2__totals__total__toggle .show-details');
      const hideDetails = cartDrawer.querySelector('.cart-drawer-v2__totals__total__toggle .hide-details');

      if (!details || !showDetails || !hideDetails) {
        return;
      }

      details.classList.toggle('hidden', !this.state.detailsOpen);
      showDetails.classList.toggle('hidden', this.state.detailsOpen);
      hideDetails.classList.toggle('hidden', !this.state.detailsOpen);
    }

    updateDivideBuySummary(cartDrawer, cart) {
      const financeWrapper = cartDrawer.querySelector('.cart-drawer-v2__totals__finance');
      const financePrice = financeWrapper?.querySelector('.finance-price');

      if (!financeWrapper || !financePrice) {
        return;
      }

      const totalPrice = Number(cart.total_price || 0);
      const minimumSpend = this.getDivideBuyMinimumSpend();
      const months = this.getOptimalPaymentMonths(totalPrice);
      const isEligible = totalPrice > minimumSpend && Boolean(months);

      financeWrapper.classList.toggle('hidden', !isEligible);

      if (!isEligible) {
        return;
      }

      financePrice.textContent = `${this.formatMoney(totalPrice / months)}/month`;
    }

    updateDivideBuyModal(cart) {
      const modal = document.querySelector('[data-modal-cart-drawer-v2-dividebuy]');

      if (!modal) {
        return;
      }

      const totalPrice = Number(cart.total_price || 0);
      const costEls = modal.querySelectorAll('[data-dividebuy-cost]');
      const thresholds = this.getDivideBuyThresholds().reverse();

      thresholds.forEach((option, index) => {
        const costEl = costEls[index];

        if (!costEl) {
          return;
        }

        const isQualified = totalPrice >= option.threshold;

        costEl.className = isQualified
          ? 'product-price__threshold-cost'
          : 'product-price__threshold-invalid';

        costEl.textContent = isQualified
          ? `${this.formatMoney(totalPrice / option.months)}/mo.`
          : `Only available above ${this.formatMoney(option.threshold)}`;
      });

      const totalEl = modal.querySelector('[data-price]');

      if (totalEl) {
        totalEl.textContent = this.formatMoney(totalPrice);
      }
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        const moneyFormat = Number(cents || 0) % 100 === 0
          ? '£{{amount_no_decimals}}'
          : (this.getThemeState()?.moneyFormat || window.Shopify.money_format || '£{{amount}}');

        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      const value = (Number(cents || 0) / 100).toFixed(2);
      const [whole, fraction] = value.split('.');
      const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return fraction === '00' ? `£${formattedWhole}` : `£${formattedWhole}.${fraction}`;
    }
  }

  const summary = new CartDrawerV2Summary();
  window[INSTANCE_KEY] = summary;
  summary.mount();
})();
